import React, { useEffect, useState } from "react";
import { Create, SimpleForm, useNotify, useRedirect } from "react-admin";

// Providers
import { usersProvider } from "../../providers/users";

// Types
import { CreateOrganizationProps, User } from "../../types/organizations";

// Components
import { CreateOrganizationForm } from "./CreateOrganizationForm";

export const CreateComponent: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const [initialData, setInitialData] = useState<CreateOrganizationProps>({
    members: [],
    users: [],
    name: "",
    active: false,
    isTecheat: false,
  });

  const onSuccess = () => {
    notify(`Organization created successfully`, { type: "success" });
    redirect("list", "organizations");
  };

  const onError = (error: any) => {
    notify(error.message, { type: "error" });
  };

  const fetchData = async () => {
    const response = await usersProvider.getUnassignedUsers();

    if (response) {
      const availableUsers: User[] = response;

      setInitialData((oldValue) => ({ ...oldValue, users: availableUsers }));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Create mutationOptions={{ onSuccess, onError }}>
      <SimpleForm mode="onBlur" reValidateMode="onBlur" defaultValues={initialData}>
        <CreateOrganizationForm formData={initialData} />
      </SimpleForm>
    </Create>
  );
};
